export default __webpack_public_path__ + "static/LpRpo01PageBanner-a25c94d313142319b77d4ae4d4724a39.png";